import { firestore } from 'firebase/app'
import { KeyDict } from "."
import { Region } from './ops'

export enum KENV {
  Dev = 'dev',
  Stage = 'stage',
  Prod = 'prod',
  Prodeu = 'prodeu'
}

export interface CloudCastConfig {
  firebase: {
    apiKey: string,
    authDomain: string,
    databaseURL: string,
    projectId: string,
    storageBucket: string,
    messagingSenderId: string
  },
  environment: KENV,
  version: string,
  k360_channel_id: string,
  portal_url: string,
  sentry_loc: string
}

export enum AWSRegion {
  UNKNOWN = 'unknown',
  MIDDLE_EAST = 'me-south-1',
  BRASIL = 'sa-east-1',
  FRANKFURT = 'eu-central-1',
  KOREA = 'ap-northeast-2',
  LONDON = 'eu-west-2',
  MUMBAI = 'ap-south-1',
  SINGAPORE = 'ap-southeast-1',
  SIDNEY = 'ap-southeast-2',
  USEAST = 'us-east-1',
  USWEST = 'us-west-1'
}

export class WRTCServer {
  url: string = ''

  constructor (data: any) {
    if (typeof data === 'string') {
      // be backward compatible with how the database used to look like
      this.url = data
      return
    }
    if (typeof data.url === 'string') this.url = data.url
    if (this.url === '') {
      console.error('No url available for WRTCServer while loading')
    }
  }
}

export class TranscodingRegion {
  awsregion: AWSRegion = AWSRegion.UNKNOWN
  name: string = ''
  keep_region_warm = false
  wrtcserver: KeyDict<WRTCServer> = {}
  rtmpserver: string|null = null
  nimbleserver: string|null = null

  constructor (data: any) {
    if (typeof data.awsregion === 'string') this.awsregion = data.awsregion
    if (typeof data.name === 'string') this.name = data.name
    if (typeof data.rtmpserver === 'string') this.rtmpserver = data.rtmpserver
    if (typeof data.keep_region_warm === 'boolean') this.keep_region_warm = data.keep_region_warm
    if (typeof data.nimbleserver === 'string') this.nimbleserver = data.nimbleserver
    if (typeof data.wrtcserver === 'object') {
      for (const [key, wowzadata] of Object.entries(data.wrtcserver)) {
        this.wrtcserver[key] = new WRTCServer(wowzadata)
      }
    } else if (typeof data.wrtcserver === 'string'){
      this.wrtcserver.default = new WRTCServer(data.wrtcserver)
    }
  }
}

export class IOSSettings {
  enabled: boolean = true
  mimimumVersion: string = '1'

  constructor (data: any) {
    if (typeof data.enabled === 'boolean') this.enabled = data.enabled
    if (typeof data.minimumVersion === 'string') this.mimimumVersion = data.minimumVersion
  }
}

export enum CastPropertyType {
  Quality = 'quality',
  Framerate = 'framerate',
  Region = 'region'
}

export interface CastProperty {
  id?: string,
  name: string,
  presets: string[],
  type: CastPropertyType,
  transcodingregion?: Region,
  wrtcserver?: string,
  largemachine_preset?: string[]
}

export interface LegalInfo {
  tosUrl: string,
  privacyUrl: string,
  tosLastPublished: firestore.Timestamp,
  privacyLastPublished: firestore.Timestamp,
}

export interface LibratoConfig {
  token: string,
  user: string
}

export interface Notifications {
  [id: string]: Notification
}

export interface Notification {
  content: string
}
